export enum MessageMeta {
  MODEL = "message",
  PK = "id",
}
